export default (state, action) => {
    switch( action.type ) {
        case 'STORE_ORDERS': 
        // console.log('inside reducer: ',action);
            return {
                ...state,
                orders: action.payload.orders,
                totalPages: action.payload.total_pages
            }
        
        case 'STORE_ORDER':
            return {
                ...state,
                orders: [
                    action.payload,
                    ...state.orders
                ]
            };

        case 'STORE_PRODUCTS':
            return {
                ...state,
                products: [
                    ...state.products,
                    ...action.payload
                ]
            }

        case 'SET_QUERY':
            return {
                ...state,
                query: action.payload
            }

        case 'TOGGLE_LOADER':
            return {
                ...state,
                loader: !state.loader,
            }

        case 'UPDATE_TOTAL_PAGE':
            return {
                ...state,
                totalPages: action.payload
            }

        case 'UPDATE_QUERY_USER':
            return {
                ...state,
                query: {
                    ...state.query,
                    user: action.payload
                }
            }

        default:
            return state;
    }
}